import { createContext, useContext } from 'react'
import type { ThemedColors } from '../utils/themedColors'

/**
 * The active app theme's color for each themed chart setting, injected by the
 * host.
 *
 * Same host-injection shape as `ChartColorPickerContext`: the app knows its
 * theme tokens, this package doesn't. Mounting it once at the root means every
 * `SettingsModal` — the one inside `EdgeChart` and the panel-level ones the
 * dashboard / scanner / history grids render — shows theme-accurate swatches
 * without prop drilling through each of them.
 *
 * Only the theme-derived keys belong here. `SettingsModal` fills in the
 * body-derived border/wick defaults itself, since those depend on the chart's
 * own settings rather than the theme.
 */
export const ChartThemeColorsContext = createContext<ThemedColors | null>(null)

export function useChartThemeColors(): ThemedColors | null {
  return useContext(ChartThemeColorsContext)
}
